import { useTitle } from 'react-use';

export default function usePageTitle(titleConstant: string, params = {}) {
  return useTitle(titleConstant, params);
}
